import {RechercheFactureDto} from "./../../../../../common/resources/resources";
import {CorrespondantDto} from "@resources/resources";
import {TranslateService} from "@ngx-translate/core";
import {FiltreItem, FiltreItems} from "./vos-filtres/filtre-item";
import {Component, EventEmitter, Output} from "@angular/core";
import {FormBuilder, FormGroup} from "@angular/forms";
import {MomentService, CorrespondantStore} from "@digicerba/common";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'factures-filtres',
  templateUrl: './factures-filtres.component.html',
  host: {'class': 'filter'}
})
export class FacturesFiltresComponent {

  filterForm: FormGroup;
  isFirstConnection : boolean;
  selectValue: Array<CorrespondantDto>;

  @Output() onFiltering = new EventEmitter<RechercheFactureDto>();
  //Ensemble des filtre possible
  filtres = new Array<FiltreItems>();
  //Filtre selectionneee
  filtre: FiltreItems;

  laboratoires = new Array<CorrespondantDto>();

  constructor(private formBuilder: FormBuilder,
              private correspondantStore: CorrespondantStore,
              private translateService: TranslateService,
              private momentService: MomentService,
              private activatedRoute: ActivatedRoute) {

    this.initForm();
  }

  ngOnInit() {
    this.isFirstConnection = true ;
    this.laboratoires = this.correspondantStore.getCorrespondants();
    this.filtres = new Array<FiltreItems>();
    this.initForm();
  }



  fillForm(laboratoires: CorrespondantDto, debutDateEmission : Date,finDateEmission:Date, debutDateFacture:Date, finDateFacture : Date){
     return this.formBuilder.group({
       laboratoires: laboratoires,
       numFacture: null,
       dateNaissance: null,
       debutDateEmission: debutDateEmission,
       finDateEmission: finDateEmission,
       debutDateFacture: debutDateFacture,
       finDateFacture: finDateFacture,
       montantMin: null,
       montantMax: null
     });
  }



  initForm() {
    let date = this.activatedRoute.snapshot.queryParamMap.get('date');
    let idCorrespondant = this.activatedRoute.snapshot.queryParamMap.get('idC');

    if(date && idCorrespondant && this.isFirstConnection){
      this.isFirstConnection = false;
      let correspondant = this.laboratoires.find(e => e.code === idCorrespondant);
      if(correspondant !==null && correspondant!==undefined){
        this.selectValue = new Array<CorrespondantDto>();
        this.selectValue.push(correspondant);
      }
      window.location.replace( window.location.href.split('?')[0]);
      this.filterForm = this.fillForm(correspondant,new Date(date),null,null,null);
    }else{
      this.filterForm = this.fillForm(
        null,
        this.momentService.addMonths(new Date(), -1),
        new Date(),
        this.momentService.addMonths(new Date(), -1),
        new Date(),
      );
    }

    this.submit();
    //FIXME : code inutile ?
    this.filterForm.valueChanges.debounceTime(500).subscribe(() => {
      this.submit();
    });
  }

  submit() {
    let rechercheFacturesDto = this.initRechercheDto();
    this.manageFilter();
    this.onFiltering.emit(rechercheFacturesDto);
  }

  private initRechercheDto(): RechercheFactureDto {
    let formValues = this.filterForm.value;
    let rechercheFacturesDto = new RechercheFactureDto();
    rechercheFacturesDto.numeroFacture = formValues.numFacture;
    rechercheFacturesDto.debutDateEmission = this.momentService.formatToLocalDate(formValues.debutDateEmission);
    rechercheFacturesDto.finDateEmission = this.momentService.formatToLocalDate(formValues.finDateEmission);
    rechercheFacturesDto.debutDateFacture = this.momentService.formatToLocalDate(formValues.debutDateFacture);
    rechercheFacturesDto.finDateFacture = this.momentService.formatToLocalDate(formValues.finDateFacture);
    rechercheFacturesDto.laboratoires = (Array.isArray(formValues.laboratoires)) ? formValues.laboratoires : [formValues.laboratoires];
    rechercheFacturesDto.montantMin = formValues.montantMin;
    rechercheFacturesDto.montantMax = formValues.montantMax;
    return rechercheFacturesDto;
  }

  private manageFilter() {
    let myFiltre = new FiltreItems;
    if (this.filtre != null) {
      myFiltre.name = this.filtre.name;
    }
    let filters = new Array<FiltreItem>();
    myFiltre.filtres = filters;

    let formValues = this.filterForm.value;


    if (formValues.laboratoires != null && formValues.laboratoires!=undefined) {
      let lab = (Array.isArray(formValues.laboratoires)) ? formValues.laboratoires : [formValues.laboratoires];
      let filtresLabo =  new FiltreItem("LABORATOIRES", "PAGE.FACTURES.FILTRE-BADGE.compte",lab);
      filtresLabo.multiple = true;
      filters.push(filtresLabo);
    }
    if (formValues.numFacture != null ) {
      filters.push(new FiltreItem("NUMERO_FACTURE", this.translateService.instant("PAGE.FACTURES.FILTRE-BADGE.num") + formValues.numFacture, formValues.numFacture))
    }
    if (formValues.debutDateEmission != null) {
      let libelleDebut = this.translateService.instant("PAGE.FACTURES.FILTRE-BADGE.debutDateEmission") + this.momentService.formatDateTime(formValues.debutDateEmission);
      filters.push(new FiltreItem("DEBUT_DATE_EMISSION", libelleDebut, formValues.debutDateEmission));
    }
    if (formValues.finDateEmission != null) {
      let libelleFin = this.translateService.instant("PAGE.FACTURES.FILTRE-BADGE.finDateEmission") + this.momentService.formatDateTime(formValues.finDateEmission);
      filters.push(new FiltreItem("FIN_DATE_EMISSION", libelleFin, formValues.finDateEmission));
    }

    if (formValues.debutDateFacture != null) {
      let libelleDebut = this.translateService.instant("PAGE.FACTURES.FILTRE-BADGE.debutDateFacture") + this.momentService.formatDateTime(formValues.debutDateFacture);
      filters.push(new FiltreItem("DEBUT_DATE_FACTURE", libelleDebut, formValues.debutDateFacture));
    }
    if (formValues.finDateFacture != null) {
      let libelleFin = this.translateService.instant("PAGE.FACTURES.FILTRE-BADGE.finDateFacture") + this.momentService.formatDateTime(formValues.finDateFacture);
      filters.push(new FiltreItem("FIN_DATE_FACTURE", libelleFin, formValues.finDateFacture));
    }
    if (formValues.montantMin != null) {
      filters.push(new FiltreItem("MONTANT_MIN", this.translateService.instant("PAGE.FACTURES.FILTRE-BADGE.montantMin") + formValues.montantMin, formValues.montantMin));
    }
    if (formValues.montantMax != null) {
      filters.push(new FiltreItem("MONTANT_MAX", this.translateService.instant("PAGE.FACTURES.FILTRE-BADGE.montantMax") + formValues.montantMax, formValues.montantMax));
    }
    this.filtre = myFiltre;
  }

  onFiltreItemRemoved(filtre: FiltreItem) {
    switch (filtre.code) {
      case "NUMERO_FACTURE": {
        this.filterForm.controls.numFacture.setValue(null);
        break;
      }
      case "LABORATOIRES": {
        if (filtre.value.length == 0) {
          filtre.value = null;
        }
        this.filterForm.controls.laboratoires.setValue(filtre.value);
        break;
      }
      case "MONTANT_MIN": {
        this.filterForm.controls.montantMin.setValue(null);
        break;
      }
      case "MONTANT_MAX": {
        this.filterForm.controls.montantMax.setValue(null);
        break;
      }
      case "DEBUT_DATE_EMISSION": {
        this.filterForm.controls.debutDateEmission.setValue(null);
        break;
      }
      case "FIN_DATE_EMISSION": {
        this.filterForm.controls.finDateEmission.setValue(null);
        break;
      }
      case "DEBUT_DATE_FACTURE": {
        this.filterForm.controls.debutDateFacture.setValue(null);
        break;
      }
      case "FIN_DATE_FACTURE": {
        this.filterForm.controls.finDateFacture.setValue(null);
        break;
      }
      default:
        throw "Illegal argument";
    }
    let rechercheFacturesDto = this.initRechercheDto();
    this.onFiltering.emit(rechercheFacturesDto);
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-factures/digicerba-factures-web/src/angular/cerba/src/app/pages/cerba/pages/factures/filtres/factures-filtres.component.ts